export const DB_TYPES = {
  MONGO: 'MONGO',
  POSTGRES: 'POSTGRES',
  NONE: 'NONE'
};




// WEBPACK FOOTER //
// config/dbTypes.js